// extracted by mini-css-extract-plugin
module.exports = {"paper":"styles_paper__1oSn_","blocks":"styles_blocks__24YGf","block":"styles_block__utM80"};